export const VARIPHI_LOGIN_GRACE_KEY = "variphi_login_grace";

const POST_LOGIN_GRACE_MS = 3000;

export function markPostLoginGracePeriod(): void {
  try {
    sessionStorage.setItem(VARIPHI_LOGIN_GRACE_KEY, String(Date.now() + POST_LOGIN_GRACE_MS));
  } catch {
    // ignore
  }
}

export function isPostLoginGraceActive(): boolean {
  try {
    const raw = sessionStorage.getItem(VARIPHI_LOGIN_GRACE_KEY);
    if (!raw) return false;
    const until = Number(raw);
    if (!Number.isFinite(until) || until <= Date.now()) {
      sessionStorage.removeItem(VARIPHI_LOGIN_GRACE_KEY);
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export function clearPostLoginGracePeriod(): void {
  try {
    sessionStorage.removeItem(VARIPHI_LOGIN_GRACE_KEY);
  } catch {
    // ignore
  }
}
